
import { api } from '@/plugins/axios'

export function inviteRecord (params) {
  return api('/invite/user/record', params)
}
